import { observable, action, computed } from 'mobx';

type IBaseFormModelInternal = {
	__validators?: [];
	__isValidForm?: boolean;
	__errorFields?: [];
};

type IFormFields<TModel> = {
	[Property in keyof TModel]: boolean | string | Date;
};

export class BaseFormModel {
	@observable validated: boolean = false;

	errorFor<T extends BaseFormModel>(name: keyof T) {
		return this.validationErrorsName(name);
	}

	isValid<T extends BaseFormModel>(name: keyof T) {
		return !this.validationErrorsName(name) || !this.validationErrorsName(name).length;
	}

	@action setValue<T extends BaseFormModel>(name: keyof T, value: boolean | string | Date) {
		const intThis = this as unknown as IFormFields<T>;
		intThis[name] = value;
	}
	
	getValue<T extends BaseFormModel>(name: keyof T): boolean | string | Date {
		const intThis = this as unknown as IFormFields<T>;
		return intThis[name];
	}

	validationErrorsName<T extends BaseFormModel>(name: keyof T) {
		const key: string = '__validateError_' + (name as string)[0].toUpperCase() + (name as string).substr(1);
		return (this as unknown as {[key: string]: string[]})[key] as string[];
	}

	fieldValidateClass<T extends BaseFormModel>(name: keyof T) {
		return this.getInvalidFields<T>().includes(name) ? 'is-invalid' : '';
	}

    @computed
    get isFormValid() {
		const intThis = this as IBaseFormModelInternal;
        return intThis.__validators ? intThis.__isValidForm : true;
    }

    getInvalidFields<T extends BaseFormModel>() {
		const intThis = this as IBaseFormModelInternal;
        return intThis.__errorFields || [] as (keyof T)[];
    }

    @computed
    get invalidFields(): string[] {
        const intThis = this as IBaseFormModelInternal;
        return intThis.__errorFields || [];
    }

    @computed
    get formValidatedClass() {
        return this.validated ? 'validated' : 'not-validated';
    }

	@action validate(): boolean {
		this.validated = true;
		return this.isFormValid ?? false;
	}
}